import { hsl } from 'polished';
export default {
    /** Hex: #1f1f1f */
    black: '#1f1f1f',
    /** Hex: #fff */
    white: '#fff',
    primary: {
        /** Hex: #2D053C */
        purple: '#2D053C',
        /** Hex: #F0EFFF */
        offWhite: '#F0EFFF',
    },
    secondary: {
        /** Hex: #FF324B */
        red: '#FF324B',
    },
    tertiary: {
        /** Hex: #32FF64 */
        green: '#32FF64',
        /** Hex: #C8FF0A */
        yellow: '#C8FF0A',
        /** Hex: #00FFFF */
        lightBlue: '#00FFFF',
        /** Hex: #2E54FF */
        darkBlue: '#2E54FF',
    },
    tint: {
        /** Hex: #3E134E */
        purple: '#3E134E',
        /** Hex: #F7F7FF */
        offWhite: '#F7F7FF',
    },
    validation: {
        /** Hex: #DA291C */
        invalid: '#DA291C',
        /** Hex: #DA291C */
        valid: '#008C15',
    },
    grey: {
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
};
